import React, { useState } from "react";
// import "antd/dist/antd.css";
// import "./index.css";
import "./VaccinationForm.css"
import { Button, Form, Input, Popconfirm, Table, Typography } from "antd";
import { DatePicker, Space } from 'antd';
import dayjs from 'dayjs';
import { DATE_FORMAT } from "../../Utils/dateFormat";

const originData = [
  {
    key: 0,
    name: `BCG`,
  },
  {
    key: 1,
    name: `HEPATITS B`,
  },
  {
    key: 3,
    name: `DPT`,
    address: ``
  }
];

const EditableCell = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  ...restProps
}) => {
  return (
    <td {...restProps}>
      {!editing ? (
        <Form.Item
          name={dataIndex}
          style={{
            margin: 0
          }}
          rules={[
            {
              required: true,
              message: `Please Input ${title}!`
            }
          ]}
        >
          <DatePicker size="large" style={{width: "50vw !important"}} defaultValue={dayjs('2015-01-01')} format={DATE_FORMAT} />
          <br/>
          <Input className="mt-2" size="large" style={{width: "50vw !important"}}/>
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};

const VaccinationForm = () => {
  const [form] = Form.useForm();
  const [data, setData] = useState(originData);
  const [editingKey, setEditingKey] = useState("");
  const [count, setCount] = useState(5);

  const isEditing = (record) => record.key === editingKey;

  const edit = (record) => {
    form.setFieldsValue({
      name: "",
      address: "",
      ...record
    });
    setEditingKey(record.key);
  };

  const cancel = () => {
    setEditingKey("");
  };

  const handleAdd = () => {
    const newData = [
        {
          key: count,
          name: `Edrward`,
          address: `London Park no. 1`
        },
    ]
    setData([...data, newData]);
    setCount(count + 1);
  };


  const save = async (key) => {
    try {
      const row = await form.validateFields();
      const newData = [...data];
      const index = newData.findIndex((item) => key === item.key);

      if (index > -1) {
        const item = newData[index];
        newData.splice(index, 1, { ...item, ...row });
        setData(newData);
        setEditingKey("");
      } else {
        newData.push(row);
        setData(newData);
        setEditingKey("");
      }
    } catch (errInfo) {
    }
  };

  const columns = [
    {
      title: "BCG",
      dataIndex: "name",
      width: "25%",
      editable: true
    },
    {
      title: "HEPATITIS B",
      dataIndex: "address",
      width: "40%",
      editable: true
    },
    {
        title: "DPT",
        dataIndex: "address",
        width: "40%",
        editable: true
      },
      {
        title: "OPV/IPV",
        dataIndex: "address",
        width: "40%",
        editable: true
      },
      {
        title: "OPV Sia",
        dataIndex: "address",
        width: "40%",
        editable: true
      },
      {
        title: "HiB",
        dataIndex: "address",
        width: "40%",
        editable: true
      },
      {
        title: "PNUEMOCOCCAL CONJUGATE VACCINE",
        dataIndex: "address",
        width: "40%",
        editable: true
      },
      {
        title: "ROTAVIRUS",
        dataIndex: "address",
        width: "40%",
        editable: true
      },
      {
        title: "MEASLES",
        dataIndex: "address",
        width: "40%",
        editable: true
      },
      {
        title: "MMR",
        dataIndex: "address",
        width: "40%",
        editable: true
      },
      {
        title: "MR",
        dataIndex: "address",
        width: "40%",
        editable: true
      },
      {
        title: "MR Sia",
        dataIndex: "address",
        width: "40%",
        editable: true
      },
      {
        title: "MMR + Varicella",
        dataIndex: "address",
        width: "40%",
        editable: true
      },
      {
        title: "VARICELLA",
        dataIndex: "address",
        width: "40%",
        editable: true
      },
      {
        title: "PNUEMOCOCCAL 23",
        dataIndex: "address",
        width: "40%",
        editable: true
      },
      {
        title: "JAPANESE ENCEPHALITIS",
        dataIndex: "address",
        width: "40%",
        editable: true
      },
      {
        title: "MENINGGOCOCCAL ACWY",
        dataIndex: "address",
        width: "40%",
        editable: true
      },{
        title: "MENINGOCOCCAL A+C",
        dataIndex: "address",
        width: "40%",
        editable: true
      },
      {
        title: "TYPHOID",
        dataIndex: "address",
        width: "40%",
        editable: true
      },
      {
        title: "HEPATITIS A",
        dataIndex: "address",
        width: "40%",
        editable: true
      },
      {
        title: "FLU",
        dataIndex: "address",
        width: "40%",
        editable: true
      },
      {
        title: "Tdap",
        dataIndex: "address",
        width: "40%",
        editable: true
      },
      {
        title: "HEPABIG",
        dataIndex: "address",
        width: "40%",
        editable: true
      },
      {
        title: "DENGUE VACCINE",
        dataIndex: "address",
        width: "40%",
        editable: true
      },
      {
        title: "Rabies Vaccine",
        dataIndex: "address",
        width: "40%",
        editable: true
      },
      {
        title: "HRIG",
        dataIndex: "address",
        width: "40%",
        editable: true
      },
      {
        title: "COVID-19",
        dataIndex: "address",
        width: "40%",
        editable: true
      },
     {
      title: "Action",
      dataIndex: "operation",
      render: (_, record) => {
        const editable = isEditing(record);
        return editable ? (
          <span>
            <Typography.Link
              onClick={() => save(record.key)}
              style={{
                marginRight: 8
              }}
            >
              Save
            </Typography.Link>
            <Popconfirm title="Sure to cancel?" onConfirm={cancel}>
              <a>Cancel</a>
            </Popconfirm>
          </span>
        ) : (
          <Typography.Link
            disabled={editingKey !== ""}
            onClick={() => edit(record)}
          >
            Edit
          </Typography.Link>
        );
      }
    }
  ];
  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }

    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: "text",
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record)
      })
    };
  });
  return (
    <Form form={form} component={false}>
      <Table
        components={{
          body: {
            cell: EditableCell
          }
        }}
        direction="vertical"
        dataSource={data}
        columns={mergedColumns}
        rowClassName="editable-row"
        pagination={{
          onChange: cancel
        }}
      />
      <Button
         onClick={handleAdd} type="primary" style={{ marginBottom: 16, marginLeft: "4%" }}>
            Add a row
      </Button>
    </Form>
  );
};

export default VaccinationForm;